export const setJobseekerData = (state, data)=> {
    state.jobseeker = data;
}